/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Link_Error_CloseInputs */



/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Connections_Link_Error_CloseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_link_error_close = /** @type {((inputs?: Connections_Link_Error_CloseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Link_Error_CloseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Begrepen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compris")
	return /** @type {LocalizedString} */ ("Got it")
});